import { Component } from '@angular/core';
import { Events, NavController, NavParams } from 'ionic-angular';
import { LoginProvider } from '$providers/login';
import { ViewProvider } from '$providers/view';
import { SenhaValidator } from '../../../../util/senhavalidator';

@Component({
  selector: 'page-recovery-password-change',
  templateUrl: 'recovery-password-change.html',
})
export class RecoveryPasswordChangePage {

  public cpf: any;
  public token: any;
  public password: '';
  public passwordConfirm: '';

  constructor(private navCtrl: NavController, navParams: NavParams, private events: Events,
    private loginProvider: LoginProvider, private viewProvider: ViewProvider) {

    this.cpf = navParams.get('cpf');
    this.token = navParams.get('token');
  }

  public submit() {
    let message = this.validate();
    if (message && message != '') {
      this.viewProvider.showMessage(message);
      return;
    }

    this.loginProvider.changePassword(this.cpf, this.token, this.password).subscribe(
      (message) => {
        if (message) {
          this.viewProvider.showMessage(message, () => {
            this.navCtrl.popToRoot();
            let user = { cpf: this.cpf, password: this.password };
            this.events.publish('login:submit', user, true);
          });
        }
      },
      (error) => { console.error(error.message) }
    );
  }

  private validate(): string {
    let message = '';
    new SenhaValidator(this.password, this.passwordConfirm).validate((msg) => message = msg);
    return message;
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/recovery-password/recovery-password-change/recovery-password-change.ts